import requestCtxs from '@/sealFilter/requestCtxs'

//新闻上传
export function queryXwxxbyCondition (data) {
    return requestCtxs({
        url: '/whgs/api/queryXwxxbyCondition',
        method: 'post',
        data
    })
}

//查询一二级分类
export function queryflxxbyCondition (data) {
    return requestCtxs({
        url: '/whgs/api/queryflxxbyCondition',
        method: 'post',
        data
    })
}

// 新增分类信息
export function InserOrUpfateXwfl (data) {
    return requestCtxs({
        url: '/whgs/api/InserOrUpfateXwfl',
        method: 'post',
        data
    })
}
//首页流程
export function queryTipinfobycondition (data) {
    return requestCtxs({
        url: '/whgs/api/queryTipinfobycondition',
        method: 'post',
        data
    })
}

//更新首页流程
export function InsertorUpdateTipInfo (data) {
    return requestCtxs({
        url: '/whgs/api/InsertorUpdateTipInfo',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/news.js